<template>
  <Transition name="fade">
    <div v-if="testsData.length">
      <div class="de-top" v-for="item in testsData" :key="item.id">
        <div class="de-img">
          <img v-lazy="item.testsCoverImg" alt="" />
          <i title="学习方式">{{ item.grade.prTeachWayName }}</i>
          <p class="grade" v-if="item.grade.grName.length <= 4">
            {{ item.grade.grName }}
          </p>
          <!-- <p class="grade1" v-if="item.grade.grName.length > 4">
        {{ item.grade.grName }}
      </p> -->
        </div>

        <div class="video-desc">
          <div class="title">
            <h2>
              {{ item.testsName }}
            </h2>
          </div>
          <div class="contain">
            <h4>包含内容：</h4>
            <div class="con-video">
              <i v-for="video in item.grade.prVideoName" :key="video.index">{{
                video
              }}</i>
            </div>
          </div>
          <div class="elec">
            <h4>电子资料：</h4>
            <div class="elec-edi">
              <i v-for="pdf in item.grade.prPdfName" :key="pdf.index">{{
                pdf
              }}</i>
            </div>
          </div>
          <div class="serve">
            <h4>增值服务：</h4>
            <div class="ser">
              <i title="课程有效期/承诺" class="teach-time">{{
                item.grade.prTeachTimeName
              }}</i>
              <i
                v-for="service in item.grade.prServiceName"
                :key="service.index"
                >{{ service }}</i
              >
            </div>
          </div>
          <div class="price">
            <div class="old-price">
              <h3>原价：</h3>
              <h3>&yen;{{ item.grade.grPrice }}</h3>
            </div>
            <div class="sale-price">
              <h3>优惠价：</h3>
              <h3>&yen;{{ item.grade.salePrice }}</h3>
            </div>
            <!-- <div class="video-num">
              <el-icon><Avatar /></el-icon>
              <h5>1980人学习过</h5>
            </div> -->

            <RouterLink
              target="_blank"
              @click="toBuy(item.id, item.clID)"
              :to="`/user/checkout?id=${item.id}&type=tests`"
            >
              <el-button size="large" type="danger">点击购买</el-button>
            </RouterLink>
            <!--  <el-button size="large" plain type="danger">加入购物车</el-button> -->
            <el-button size="large" plain>在线咨询</el-button>
          </div>

          <div class="share">
            <h4>分享到</h4>
            <img src="../../../../public/icon/微信logo.png" alt="" />
            <img src="../../../../public/icon/QQlogo.png" alt="" />
            <img src="../../../../public/icon/QQ空间logo.png" alt="" />
            <img src="../../../../public/icon/微博logo.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <TestsDescSkeleton v-else />
  </Transition>
</template>

<script>
import TestsDescSkeleton from "./tests-desc-skeleton.vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
export default {
  name: "VideoDesc",
  components: {
    TestsDescSkeleton,
  },
  props: {
    testsData: {
      type: Array,
      default: () => [],
    },
  },

  setup(props, { emit }) {
    const store = useStore();
    const toBuy = (id, clID) => {
      try {
        const { profile } = store.state.user;
        if (!profile.token) {
          ElMessage({
            message: "购买前请先登录",
            type: "warning",
          });
        }
      } catch (error) {
        console.log(error);
      }
    };
    return { toBuy };
  },
};
</script>

<style lang="less" scoped>
.de-top {
  display: flex;
  align-items: center;
  margin-top: 15px;
  height: 380px;
  border-radius: 5px;
  background: #fff;
  .de-img {
    position: relative;
    display: flex;
    justify-content: center;
    width: 550px;
    height: 380px;
    i {
      display: inline-block;
      position: absolute;
      top: 24px;
      right: 4px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      color: #fff;
      font-size: 12px;
      background: #0a7fec;
      border-radius: 5px;
      padding-left: 5px;
      padding-right: 5px;
    }
    img {
      align-self: center;
      margin-left: 10px;
      width: 500px;
      height: 335px;
      border-radius: 5px;
    }
    .grade {
      position: absolute;
      font-weight: bold;
      font-size: 30px;
      top: 72.9%;
      left: 41%;
    }
    .grade1 {
      position: absolute;
      font-weight: bold;
      font-size: 30px;
      top: 72.9%;
      left: 36.3%;
    }
  }
  .video-desc {
    width: 740px;
    margin: 0px 10px 5px 15px;
    .title {
      margin-top: 5px;
      //height: 45px;
      h2 {
        display: -webkit-box;
        max-height: 75px;
        word-break: break-all;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
      }
    }
    .contain {
      display: flex;
      align-items: center;
      width: 100%;
      //height: 75px;
      height: 65px;
      flex-wrap: wrap;
      border-bottom: 1px dashed #ebebeb;
      h4 {
        width: 70px;
      }
      .con-video {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 620px;
        //padding-top: 10px;
        i {
          display: block;

          //width: 85px;
          padding-left: 5px;
          padding-right: 5px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin: 3px 3px 3px 3px;
          color: @shColor;
          background-color: rgb(245, 245, 245);
          border-radius: 5px;
        }
      }
    }
    .elec {
      display: flex;
      align-items: center;
      height: 65px;
      //height: 40px;
      border-bottom: 1px dashed #ebebeb;
      h4 {
        width: 70px;
      }
      .elec-edi {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 620px;
        //padding-top: 10px;
        i {
          display: block;

          //width: 85px;
          padding-left: 5px;
          padding-right: 5px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin: 3px 3px 3px 3px;
          color: @shColor;
          background-color: rgb(245, 245, 245);
          border-radius: 5px;
        }
      }
    }
    .serve {
      display: flex;
      align-items: center;
      height: 65px;
      //background: #666;
      border-bottom: 1px dashed #ebebeb;
      h4 {
        width: 70px;
      }
      .ser {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 620px;
        //padding-top: 10px;
        i {
          display: block;

          //width: 85px;
          padding-left: 5px;
          padding-right: 5px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin: 3px 3px 3px 3px;
          color: @shColor;
          background-color: rgb(245, 245, 245);
          border-radius: 5px;
        }
        .teach-time {
          font-weight: bold;
          color: #e6395e;
          background-color: #f5f5f5;
        }
      }
    }
    .price {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 50px;
      width: 690px;
      margin: 0 auto;
      .old-price {
        display: flex;
        align-items: center;
        h3 {
          text-decoration: line-through;
        }
      }
      .sale-price {
        display: flex;
        align-items: center;
        h3 {
          color: red;
        }
      }
      .video-num {
        display: flex;
        align-items: center;
        color: #666;
      }
    }

    .share {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 15px;
      border-radius: 8px;
      height: 35px;
      //background: #f5f5f5;
      h4 {
        margin-right: 15px;
        color: #666;
      }
      img {
        width: 30px;
        height: 30px;
        margin-right: 15px;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
